import { Badge, Group, SegmentedControl, Stack, Text } from '@mantine/core';
import type { NotificationRoleState } from '../../types/notification-settings';

type RoleChoice = 'inherit' | 'on' | 'off';

interface RoleCellProps {
  label: string;
  state: NotificationRoleState;
  value: boolean | null;
  inheritLabel: string;
  changed: boolean;
  onChange: (value: boolean | null) => void;
}

function toChoice(value: boolean | null): RoleChoice {
  return value === null ? 'inherit' : value ? 'on' : 'off';
}

function fromChoice(choice: string): boolean | null {
  return choice === 'inherit' ? null : choice === 'on';
}

export function RoleCell({ label, state, value, inheritLabel, changed, onChange }: RoleCellProps) {
  const effective = value ?? state.inherited;
  return (
    <Stack spacing={4} miw={220}>
      <Group spacing="xs">
        <Text size="sm" weight={600}>
          {label}
        </Text>
        <Badge size="xs" variant="light" color={effective ? 'green' : 'gray'}>
          {effective ? 'sends' : 'off'}
        </Badge>
        {changed && (
          <Badge size="xs" variant="outline" color="orange">
            unsaved
          </Badge>
        )}
      </Group>
      <SegmentedControl
        size="xs"
        color="bagel"
        value={toChoice(value)}
        onChange={(choice) => onChange(fromChoice(choice))}
        data={[
          { label: inheritLabel, value: 'inherit' },
          { label: 'On', value: 'on' },
          { label: 'Off', value: 'off' },
        ]}
      />
      <Text size="xs" color="dimmed">
        {inheritLabel}: {state.inherited ? 'on' : 'off'}
      </Text>
    </Stack>
  );
}
